import { combineReducers } from 'redux';
import Attach from './attach.reducer';
import Tracking from './tracking.reducer';

export default combineReducers({ Attach, Tracking });
